import React, { Component } from 'react';
import Swiper from 'react-id-swiper';
import { Link } from 'react-router';
import $ from 'jquery';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

export default class WebStoreBlocks extends Component{
	constructor(props){
		super(props);
		this.state={
			deal_offers: [],
		    deal_details:[],
		    arrowImage:'',
		    dealoffer_name:'',
		    bgImage:'',
		    deal_bg_img:'',
		    isToggle:''
		};
		this.getStoreBlocks=this.getStoreBlocks.bind(this);
		this.getblockDetails=this.getblockDetails.bind(this);
		this.goNext = this.goNext.bind(this);
    	this.goPrev = this.goPrev.bind(this);
    	this.goNextInner = this.goNextInner.bind(this);
    	this.goPrevInner = this.goPrevInner.bind(this);
    	this.swiper = null;
    	this.swiper1 = null;
	}
	componentDidMount()
  	{
      	this.getStoreBlocks();
	}
	getStoreBlocks()
	{
     	var data1={from:'desktop_web'};
      	var data2=JSON.stringify(data1);
      	$.ajax({
        	method:'post',
          	url:baseUrl+'getdealOffers',
          	dataType:'json',
          	data: {req:data2},
          	success:function(data)
          	{
            	this.setState({
              		deal_offers: data.deal_offers,
            	});
            	this.getblockDetails(data.deal_offers[0].id);
          	}.bind(this),
          	error:function(err)
          	{
          	}
      	});
	}
	getblockDetails(block_id)
	{
	    this.setState({
	      arrowImage: block_id,
	    });
	    var baseUrl='https://aquadeals.in/admin/web3/user/';
	    var data1={from:'desktop_web',id:block_id};
	    var data2=JSON.stringify(data1);
	    $.ajax({
		    method: 'POST',
		    url:baseUrl+'getOfferDeals',
		    dataType:'json',
		    data:{req:data2},
		    success:function(data)
		    {
		    	if(data.status === 'success')
		    	{	
			        if(this.state.storeid !== block_id)
			        {
			        	this.setState({isToggle:true});
			        } 
			        else
			        {
			        	this.setState({isToggle:!this.state.isToggle});
			        }

			        this.setState({
			          deal_details:data.deal_blocks,
			          deal_bg_img: baseAssets+'images/'+data.blck_img,
			          dealoffer_name:data.arrayname,
			          storeid:block_id,
			        });
		        }

		    }.bind(this),
		    error:function(err)
		    {
		    }
	    });
	}
	goNext()
	{
	    if(this.swiper) this.swiper.slideNext()
	}
	goPrev()
	{
    	if(this.swiper) this.swiper.slidePrev()
  	}
  	goNextInner()
	{
	    if(this.swiper1) this.swiper1.slideNext()
	}
	goPrevInner()
	{
    	if(this.swiper1) this.swiper1.slidePrev()
  	}

	render(){
		var params ={
	   		paginationClickable: true,
		    spaceBetween: 10,
		    slidesPerView: 4,
		    slidesPerGroup: 4,
		    // autoplay:3000,
	      	// autoplayDisableOnInteraction:false,
	     	//  pagination: {
		    //     el: '.swiper-pagination',
		    //     type: 'bullets',
		    //     clickable: true
		    // },
		    // pagination: '.swiper-pagination',
		    navigation: {
		        nextEl: '.swiper-button-next1',
		        prevEl: '.swiper-button-prev1'
		    },
   		}
   	var brandparams ={
   		    paginationClickable: true,
		    spaceBetween: 20,
		    slidesPerView: 6,
		    slidesPerGroup:6,
		    navigation: {
		        nextEl: '.swiper-button-next',
		        prevEl: '.swiper-button-prev'
		    },
   	 }	
		var mob_swipe_blocks = this.state.deal_offers.map(function(block,index){
        	return(
					<div className="item" onClick={()=> {this.getblockDetails(block.id)}}>
			            <div className="web_store_img_blk  text-center">
			            	<a>
			            		<img src={baseAssets+'images/'+block.img} alt="" />
			            	</a>
			            	<div className="text-center">
			            	   <h6>{block.type}</h6>
			            	  {this.state.isToggle ? <i>{this.state.storeid === block.id ? <img src={baseAssets+'images/'+block.arrow_img} alt="" /> : ''}</i>  :''}
			                </div>
			            </div>
			        </div>
				);
	      	}.bind(this));

		var swipe_all='';
		if(this.state.deal_details.length > 0){
        swipe_all=this.state.deal_details.map(function(block,index){
          return(
            <div className={block.pro_title ==="View More" ? "web_swipe_dtls_content1" : "web_swipe_dtls_content"}>
              {this.state.dealoffer_name==="Imported" ? 
              <Link to={'/web/pdeals/'+block.url_dtype+'/'+block.url_name+'/'+block.id+'/'+block.type+'/'+block.pro_id} >
                  {block.image ==='' ? '' : <i className="web_store_img"><img className="web_sw_dtls_img" src={'https://aquadeals.in/admin/assets/images/'+block.image} alt=" " /></i> }
                  {block.brand_name ? <h5 className="web_sw_brand_name">{block.brand_name}</h5> : <h5 className="web_sw_brand_name">&nbsp;</h5>}
                  {block.pro_title ? <h6 className="web_dtls_name">{block.pro_title}</h6> : <h6 className="web_dtls_name">&nbsp;</h6>}
                  {block.mrp ? <p className="web_sw_dtls_price">MRP ₹ {block.mrp}</p> : <p className="web_sw_brand_price">&nbsp;</p> }
              </Link>
              :
              <div>
              {block.pro_title==="View More" ? 
              <Link to={'/web/stores/'+block.url_name+'/'+block.id} >
                {block.image ==='' ? '' : <img className="sw_dtls_img" src={'https://aquadeals.in/admin/assets/images/'+block.image} alt=" " />}
                <h5 className="m_dtls_name organic_dtls_name">{block.pro_title}</h5>
              </Link> :
              <Link to={'/web/pdetails/'+block.url_dtype_name+'/'+block.url_cat_name+'/'+block.url_brand_name+'/'+block.url_product_name+'/'+block.pro_id+'/'+block.id}> 
                {block.image ==='' ? '' : <i className="web_store_img"><img className="web_sw_dtls_img" src={'https://aquadeals.in/admin/assets/images/'+block.image} alt=" " /></i>}
                {block.brand_name ? <h5 className="web_sw_brand_name">{block.pro_title}</h5> : <h5 className="web_sw_brand_name">&nbsp;</h5> }
                {block.pro_title ? <h6 className="web_dtls_name">{block.brand_name}</h6> : <h6 className="web_dtls_name">&nbsp;</h6>}
                {block.mrp ? <p className="web_sw_dtls_price">MRP ₹ {block.mrp}</p> :<p className="web_sw_dtls_price">&nbsp;</p>}
              </Link> }
              </div>
            }
            </div>
          );
        }.bind(this));
      }
      return(
			<section className="container our_stores">
			    <div className="row">
			        <h4 className="web_blk_titles">AD Stores</h4>
	                <div className="pro_sld_ctrls">
			            <a className="left carousel-control pro_sld_lft" onClick={this.goPrev}>
			              <span className="pro_sld_arow" aria-hidden="true"><img src={baseAssets+'images_web/left_arrow.png'} alt="" /></span>
			              <span className="sr-only">Previous</span>
			            </a>
			            <a className="right carousel-control pro_sld_rgt" onClick={this.goNext}>
			              <span className="pro_sld_arow" aria-hidden="true"><img src={baseAssets+'images_web/right_arrow.png'} alt="" /></span>
			              <span className="sr-only">Next</span>
			            </a>
	            	</div>
			    </div>
		      	{/* slideshow start */}
		      	<div className="row">
		        	<div id="carousel-our-stores" className="carousel slide carousel-our-stores" data-ride="carousel" data-type="multi" data-interval="false">
						<Swiper {...params}  key={mob_swipe_blocks.length} ref={node => node ? this.swiper = node.swiper : ''}>
							{mob_swipe_blocks}
						</Swiper>	
						{this.state.isToggle ?
						<div className="web_swipe_imp_bg" style={{background:'url('+ this.state.deal_bg_img +')'}}>
				            {swipe_all.length > 0 ? 
					            <div>  
					              <div className="pro_sld_ctrls pro_sld_ctrls_innerstores">
						            <a className="left carousel-control pro_sld_lft" onClick={this.goPrevInner}>
						              <span className="pro_sld_arow" aria-hidden="true"><img src={baseAssets+'images_web/left_arrow.png'} alt="" /></span>
						              <span className="sr-only">Previous</span>
						            </a>
						            <a className="right carousel-control pro_sld_rgt" onClick={this.goNextInner}>
						              <span className="pro_sld_arow" aria-hidden="true"><img src={baseAssets+'images_web/right_arrow.png'} alt="" /></span>
						              <span className="sr-only">Next</span>
						            </a>
				            	  </div> 
				            	  <div id="carousel-our-stores1"> 
					                  <Swiper {...brandparams}   key={swipe_all.length} ref={node => node ? this.swiper1 = node.swiper : ''}>
					                   {swipe_all}
					                 </Swiper> 
				                 </div>
				               </div>
				            :''
				            }
				        </div>
				        :''}
					</div>
		      	</div>
		      {/* slideshow end */}
		  </section>
		)
	}
}


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Stores/WebStoreBlocks.js
 **/